import { ValidatorService } from '../../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-select2-single',
  templateUrl: './select2-single.component.html',
  styleUrls: ['./select2-single.component.scss']
})
export class Select2SingleComponent implements OnInit {

  @Input() public default:string;
  @Input() public options:any[];
  @Input() public label:string;
  @Input() public key:string;
  @Input() public model:any;
  @Input() public element:string;
  @Input() public response:string;
  @Input() public disabled:boolean = false;
  @Input() public error: any;

  private data: any[];

  @Output() public SelectCallback:EventEmitter<any> = new EventEmitter;
  constructor(private validatorService: ValidatorService) { }

  ngOnInit() {

    if(this.element){
      // se debe renombrar el this global para poder utilizarlo en el setTimeOut
      let _this = this;

      // se debe colocar un timeout para que de tiempo de que se cargue el DOM
      setTimeout(function() {

        // iniciando input y recibiendo model
        _this.input().select2({
          'data': _this.getData()
        });

        // enviamos al padre nuestro valor si es que hay cambios dentro del componente
        _this.input().on('select2:select', function (e) {
          _this.emit();
        });

      }, 500);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.rebuild();
  }

  getData() {
    let _this = this;

    // se regresa un mensaje predeterminado si es que no existen registros
    if (!this.options || this.options.length <= 0) {
      this.data = [{
        id: -1,
        text: 'No existen registros'
      }]
      return this.data;
    }

    this.data = $.map(this.options, function (obj) {
      obj.id = obj[_this.key];
      obj.text = obj[_this.label];

      if(_this.model && _this.response == 'key' && _this.model == obj.id) {
        obj.selected = true;
      } else if(!$.isEmptyObject(_this.model) && _this.response != 'key' && _this.model[_this.key] == obj.id) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }

      return obj;
    });

    this.data.unshift({
      id: -1,
      text: this.default
    });

    return this.data;
  }

  rebuild() {
    this.input().empty();
    this.input().select2({
      'data': this.getData()
    });
  }

  // emite la respuest al callback
  emit(){
    this.SelectCallback.emit(this.getResponse());
  }

  // regresamos valor actual del select en key o en model
  getResponse(){
    let response;
    if (this.response == 'key') {
      response = (this.input().val() != "-1")?this.input().val():'';
    } else {
      response  = this.search();
    }
    return response;
  }

  // busca entre los options el seleccioando para regresarlo
  search() {
    let find = {};
    for(let option of this.options){
      if(option[this.key] == this.input().val()){
        find = option;
      }
    }

    return find;
  }

  input(){
    return $('#' + this.element);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/tools/select2/select2-single/select2-single.component.ts